import * as ACTION_TYPES from './actiontypes';

const detailReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.INIT_REQUEST: {
      return { ...state, isLoading: true, loadingMessage: 'Initializing page' };
    }

    case ACTION_TYPES.INIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isFailedInit: true,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.INIT_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        details: {
          ...payload
        }
      };
    }

    case ACTION_TYPES.HYDRATE_ENCOUNTER_AUDIT_REASONS: {
      const { payload: { encounterAuditReasons } } = action;

      return {
        ...state,
        details: {
          ...state.details,
          encounterAuditReasons
        }
      };
    }

    default:
      throw new Error('detailReducer default case should never be hit')
  }
};

export default detailReducer;
